<template>
    <div class="g cell">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data: function(){
            
            return {}
        },
    }
</script>

<style scoped lang="scss">
    .g.cell {
    
    }
</style>
